import axios from "./axios";

/**
 * 帮助文档API
 */

/**
 * 获取帮助文档内容
 * @param {string} documentPath - 文档路径，如 "help/2025-7-23_flight-schedule-import-dates-1.md"
 * @returns {Promise<string>} 文档内容
 */
export const getHelpDocumentContent = async (documentPath) => {
    try {
        // 直接从后端API获取，不做fallback
        const response = await axios.get(`/v1/help-documents/${encodeURIComponent(documentPath)}`);
        return response.data.content;
    } catch (error) {
        console.error("获取帮助文档失败:", error);
        throw new Error(`无法获取文档内容: ${error.message}`);
    }
};

/**
 * 获取帮助文档列表
 * @returns {Promise<Array>} 文档列表
 */
export const getHelpDocumentList = async () => {
    try {
        const response = await axios.get("/v1/help-documents");
        return response.data.documents;
    } catch (error) {
        console.error("获取帮助文档列表失败:", error);
        throw new Error(`无法获取文档列表: ${error.message}`);
    }
};

/**
 * 检查文档是否存在
 * @param {string} documentPath - 文档路径
 * @returns {Promise<boolean>} 是否存在
 */
export const checkHelpDocumentExists = async (documentPath) => {
    try {
        const response = await axios.head(`/v1/help-documents/${encodeURIComponent(documentPath)}`);
        return response.status === 200;
    } catch (error) {
        return false;
    }
};
